import { useEffect } from 'react';
import { hasAuthErrorParams, hasAuthSuccessParams } from './search-params';
import { useAuth } from './useAuth';
import { auth0Client } from './auth0Client';

/**
 * AuthProvider 以下の Component 内で認証情報で block するための hooks
 * TODO: AuthProvider との二重処理かつ順序保証がないため、 Loader 等に逃がす
 */
export function useLoginRequired() {
  const { login } = useAuth();
  useEffect(() => {
    (async () => {
      // 認証コールバックの search params が付与されている場合、 AuthProvider でハンドルしているここでは何もしない
      if (hasAuthSuccessParams() || hasAuthErrorParams()) {
        return;
      }
      await auth0Client.checkSession();
      const user = await auth0Client.getUser();
      if (!user) {
        await login();
      }
    })();
  }, [login]);
}
